import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import React, { Component, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { Pagination } from 'dg-pagination';
import { dgWithReducer } from 'dg-utils';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import { deleteUser, getUsers } from './userActions.mjs';
import userReducer from './userReducer.mjs';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ListOptions = /*#__PURE__*/function (_Component) {
  _inherits(ListOptions, _Component);

  var _super = _createSuper(ListOptions);

  function ListOptions(props) {
    var _this;

    _classCallCheck(this, ListOptions);

    _this = _super.call(this, props);
    _this.state = {
      isDashboardsOpen: false
    };
    return _this;
  }

  _createClass(ListOptions, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("nav", {
        className: "dg-admin-ListOptions"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "dg-admin-ListOptions-nav"
      }, /*#__PURE__*/React.createElement("li", {
        className: "nav-item ".concat(this.state.isDashboardsOpen ? "show" : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "nav-link dropdown",
        onClick: function onClick() {
          return _this2.setState({
            isDashboardsOpen: !_this2.state.isDashboardsOpen
          });
        }
      }, /*#__PURE__*/React.createElement("svg", {
        "aria-hidden": "true",
        focusable: "false",
        "data-prefix": "fas",
        "data-icon": "ellipsis-v",
        className: "svg-inline--fa fa-ellipsis-v fa-w-6",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 192 512"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z",
        className: "fa-primary"
      })), /*#__PURE__*/React.createElement("div", {
        className: "dropdown-menu ".concat(this.state.isDashboardsOpen ? "show" : '')
      }, this.props.onEdit ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "dropdown-link",
        onClick: this.props.onEdit
      }, /*#__PURE__*/React.createElement("svg", {
        "aria-hidden": "true",
        focusable: "false",
        "data-prefix": "fas",
        "data-icon": "edit",
        className: "svg-inline--fa fa-edit fa-w-18",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 576 512"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z",
        className: "fa-primary"
      })), /*#__PURE__*/React.createElement("span", {
        className: "link-text"
      }, "Edit")) : '', /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "dropdown-link",
        onClick: this.props.onDelete
      }, /*#__PURE__*/React.createElement("svg", {
        "aria-hidden": "true",
        focusable: "false",
        "data-prefix": "fas",
        "data-icon": "trash-alt",
        className: "svg-inline--fa fa-trash-alt fa-w-14",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z",
        className: "fa-primary"
      })), /*#__PURE__*/React.createElement("span", {
        className: "link-text"
      }, "Delete")))))));
    }
  }]);

  return ListOptions;
}(Component);

function UserList(props) {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useState3 = useState(10),
      _useState4 = _slicedToArray(_useState3, 2),
      page_size = _useState4[0],
      setPageSize = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      total_pages = _useState6[0],
      setTotalPages = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      total_items = _useState8[0],
      setTotalItems = _useState8[1];

  useEffect(function () {
    paginate(page, page_size, props === null || props === void 0 ? void 0 : props.query);
  }, [props === null || props === void 0 ? void 0 : props.query]);

  var paginate = function paginate(page, page_size) {
    props.getUsers(page, page_size, props === null || props === void 0 ? void 0 : props.query).then(function (res) {
      setPage(res.page);
      setPageSize(res.page_size);
      setTotalPages(res.total_pages);
      setTotalItems(res.total_items);
    })["catch"](function (res) {
      Swal.fire("Error", res.message, "error");
    });
  };

  var _onDelete = function onDelete(event, value) {
    event.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(result) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!result.isConfirmed) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return props.deleteUser(value._id);

              case 3:
                Swal.fire("Deleted!", "User has been deleted.", "success");
                paginate(page, page_size, props === null || props === void 0 ? void 0 : props.query);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  };

  var onCreate = function onCreate(event) {
    event.preventDefault();
    props.navigate("/admin/user/create");
  };

  var _onEdit = function onEdit(event, value) {
    event.preventDefault();
    props.navigate("/admin/user/edit/".concat(value._id));
  };

  var rows = [];

  if (props.users && props.users.users && props.users.users.length > 0) {
    rows = props.users.users.map(function (value, index) {
      return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, value.first_name), /*#__PURE__*/React.createElement("td", null, value.email), /*#__PURE__*/React.createElement("td", null, value.isAdmin ? "Admin" : "User"), /*#__PURE__*/React.createElement("td", null, value.createdAt ? "".concat(new Date(value.createdAt).toLocaleDateString(), " ").concat(new Date(value.createdAt).toLocaleTimeString()) : ""), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ListOptions, {
        onEdit: function onEdit(e) {
          return _onEdit(e, value);
        },
        onDelete: function onDelete(e) {
          return _onDelete(e, value);
        }
      })));
    });
  } else {
    rows = [/*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: "5"
    }, "No Users Available ..."))];
  }

  return /*#__PURE__*/React.createElement("main", {
    className: "dg-admin-main"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dg-admin-List-Container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dg-admin-header-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-text"
  }, /*#__PURE__*/React.createElement("h1", null, "All Users")), /*#__PURE__*/React.createElement("div", {
    className: "header-button"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      return onCreate(e);
    },
    className: "btn-primary"
  }, "Create"))), /*#__PURE__*/React.createElement("div", {
    className: "dg-admin-list"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Name"), /*#__PURE__*/React.createElement("th", null, "Email"), /*#__PURE__*/React.createElement("th", null, "Role"), /*#__PURE__*/React.createElement("th", null, "Created On"), /*#__PURE__*/React.createElement("th", null, "Actions"))), /*#__PURE__*/React.createElement("tbody", null, rows)), /*#__PURE__*/React.createElement(Pagination, {
    type: "Standard",
    paginate: paginate,
    page_size: page_size,
    page: page,
    total_pages: total_pages,
    total_items: total_items
  }))));
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    users: state.users
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    deleteUser: function deleteUser$1(data) {
      return dispatch(deleteUser(data));
    },
    getUsers: function getUsers$1(page, page_size, query) {
      return dispatch(getUsers(page, page_size, query));
    }
  };
};

var userList_component = connect(mapStateToProps, mapDispatchToProps)(dgWithReducer(UserList, "users", userReducer));

export { ListOptions as L, userList_component as u };
